import gtagEventEmitter from "helpers/gtagEventEmitter";

/**
 * Fires when the review section scrolls into viewport (>= 50% visible).
 */
export const trackReviewSectionViewed = ({
  propertyId,
  cityId,
  totalReviewCount,
  aiSummaryRendered,
}: {
  propertyId: string | number;
  cityId: string | number;
  totalReviewCount: number;
  aiSummaryRendered: boolean;
}) => {
  gtagEventEmitter({
    action: "review_section_viewed",
    category: "reviews",
    property_id: propertyId,
    city_id: cityId,
    total_review_count: totalReviewCount,
    ai_summary_rendered: aiSummaryRendered,
  });
};

/**
 * Fires when user interacts with the AI summary tooltip/info icon.
 */
export const trackAiSummaryInteracted = ({
  propertyId,
  actionType,
}: {
  propertyId: string | number;
  actionType: "HOVER" | "CLICK" | "TOOLTIP_OPEN";
}) => {
  gtagEventEmitter({
    action: "ai_summary_interacted",
    category: "reviews",
    property_id: propertyId,
    action_type: actionType,
  });
};

/**
 * Fires when user expands the full parameter/category drawer.
 */
export const trackParameterDrawerExpanded = ({
  propertyId,
  initialVisibleParameters,
}: {
  propertyId: string | number;
  initialVisibleParameters: string[];
}) => {
  gtagEventEmitter({
    action: "parameter_drawer_expanded",
    category: "reviews",
    property_id: propertyId,
    initial_visible_parameters: initialVisibleParameters,
  });
};

/**
 * Fires when user clicks the "Helpful" button on a review.
 */
export const trackHelpfulButtonClicked = ({
  reviewId,
  propertyId,
  isVerifiedStay,
  priorVoteCount,
}: {
  reviewId: string;
  propertyId: string | number;
  isVerifiedStay: boolean;
  priorVoteCount: number;
}) => {
  gtagEventEmitter({
    action: "helpful_button_clicked",
    category: "reviews",
    review_id: reviewId,
    property_id: propertyId,
    is_verified_stay: isVerifiedStay,
    prior_vote_count: priorVoteCount,
  });
};
